import React from "react";

import Button from "@common/components/Button/Button";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./MetricCardEmptyState.styles";

interface MetricCardEmptyStateProps {
  text: string;
  onButtonClick: () => void;
  buttonText: string;
  column?: boolean;
}

export const MetricCardEmptyState = ({ text, onButtonClick, buttonText, column }: MetricCardEmptyStateProps) => {
  return (
    <Styled.MetricCardEmptyStateRoot
      $justifyContent={column ? "center" : "start"}
      $alignItems={column ? "center" : "flex-start"}
    >
      <Flex
        style={{ maxWidth: column ? "18rem" : "100%" }}
        $column={column}
        $gap={1.2}
      >
        <Paragraph
          style={{ textAlign: column ? "center" : "start", flex: 1 }}
          p2
        >
          {text}
        </Paragraph>
        <Button
          style={{ boxSizing: "border-box" }}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </Flex>
    </Styled.MetricCardEmptyStateRoot>
  );
};
